<template>
  <Sidebar :props-handle-click-close="toggleSidebar" class="test">
    <TitleBlock text="MyPC" type="alternative" />
    <div
      class="profile-sidebar section section-border--top section-border--right"
    >
      <div class="profile-sidebar__wrapper">
        <template v-for="(item, index) in profileMenu.submenu">
          <nuxt-link
            v-if="
              !item.toolsAccessRequired ||
              (item.toolsAccessRequired && hasAccessTools)
            "
            :key="index"
            :to="item.link"
            class="profile-sidebar__item"
          >
            {{ item.title }}
            <span
              v-if="watchlist && item.title === 'Watchlist'"
              class="counter"
              >{{ watchlist.length }}</span
            >
          </nuxt-link>
        </template>
      </div>
    </div>
  </Sidebar>
</template>

<script>
import { mapState } from "vuex";
import { profileMenu } from "@/config";
import { checkAccess } from "@/utils/constants";

export default {
  name: "ProfileMenu",
  components: {
    TitleBlock: () => import("@/components/elements/TitleBlock"),
  },
  data() {
    return { profileMenu };
  },
  async fetch({ store }) {
    await store
      .dispatch("Main/getViewData", {
        url: "/my-watchlists",
      })
      .then(({ data }) => {
        store.commit("Main/setData", {
          label: "watchlist",
          data,
        });
      })
      .catch((error) => console.error(error));
  },

  computed: {
    ...mapState("Main", ["watchlist"]),
    ...mapState("Auth", ["subscriptions"]),
    hasAccessTools(state) {
      if (
        state.subscriptions.legacy_permissions !== null &&
        state.subscriptions.legacy_permissions.length > 0
      )
        return true;
      return checkAccess(state.subscriptions.permissions, "tool");
    },
  },

  methods: {
    toggleSidebar() {
      this.showFilters = !this.showFilters;
      if (this.showFilters) {
        document.documentElement.classList.add("lock-scroll_only-devices");
      } else {
        document.documentElement.classList.remove("lock-scroll_only-devices");
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.profile-sidebar {
  &__wrapper {
    padding: 1rem 2rem 0 0;
  }

  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border-bottom: 1px dashed $border;
    text-decoration: none;
    font-size: 1.3rem;
    font-weight: 700;
    color: #262a2e;
    margin-bottom: 1rem;

    &.nuxt-link-exact-active {
      color: $brightBlue;
    }

    .counter {
      display: flex;
      align-items: center;
      justify-content: center;
      color: $white;
      font-size: 0.9rem;
      background: $red;
      padding: 0 0.7rem;
      border-radius: 2rem;
      min-width: 2rem;
      height: 1.4rem;
    }
  }
}
</style>
